import { Component, Input } from '@angular/core';
import { CiType } from 'projects/dop-ordering/src/public-api';
import { MonographToolTip } from '../models/monograph/monograph-tool-tip.model';

@Component({
  selector: 'app-monograph-tool-tip',
  templateUrl: './monograph-tool-tip.component.html',
  styleUrls: ['./monograph-tool-tip.component.scss']
})
export class MonographToolTipComponent {

  @Input() toolTipData: MonographToolTip;

  get ciTypes() { return CiType; }
}
